import { render, staticRenderFns } from "./MontaggioBobina.vue?vue&type=template&id=445f495f&scoped=true&"
import script from "./MontaggioBobina.vue?vue&type=script&lang=js&"
export * from "./MontaggioBobina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445f495f",
  null
  
)

export default component.exports